/**
 * Resolves where the renter should be sent next from the certification page.
 * Backend (`GET /api/v2/interview/<survey_id>/continue/`) re-reads survey
 * state on every call and applies the data-transfer / questionnaire
 * decision tree, so the frontend never has to branch on stale survey
 * fields itself.
 */
import axios from 'src/utils/axios';

export type ContinueCertificationTarget = 'data-transfer' | 'questionnaire';

export interface ContinueCertificationResponse {
  redirect_to: ContinueCertificationTarget;
  /** True when survey.is_started is set in the DB — use this to
   *  distinguish "Continue my application" from "Start Interview" without
   *  depending on the Redux cert.surveys array which may be stale or
   *  missing is_started due to getMemberSurvey() resolution issues. */
  survey_started: boolean;
}

export async function fetchContinueCertification(
  surveyId: number
): Promise<ContinueCertificationResponse> {
  const { data } = await axios.get<ContinueCertificationResponse>(
    `v2/interview/${surveyId}/continue/`
  );
  return data;
}
